define('views/modules/template/edit/calendar/personal-data/personal-data-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // model
    'models/calendar/item/personal-data',
    // views
    'views/modules/template/edit/calendar/template-calendar-item-panel',
    'views/modules/template/edit/calendar/personal-data/personal-data-content',
], function(
    // Libs
    _, Backbone, U,
    // model
    MPersonalData,
    // views
    VTemplateCalendarItemPanel,
    VTemplatePersonalDataDetails
) {

    var VTemplatePersonalDataPanel = VTemplateCalendarItemPanel.extend({
        header: {
            title: "calendar:Personal data",
            subtitle: "calendar:Add/Modify a personal data",
        },
        tabs: [{ id: 'details', title: 'Details', icon: 'sl-icon-info', active: true, callback: 'showDetails' }],

        content: {
            details: VTemplatePersonalDataDetails,
        },

        initialize: function(options) {
            this.model = new MPersonalData();
        },
    });

    return VTemplatePersonalDataPanel;
});

